// SPDX-License-Identifier: AGPL-3.0-or-later
// Adapted 2026-09-17 from Duarte Santos/openGym Library.jsx at a68a88d2.
// Preserves active-equipment narrowing and effective-filter fallback; CSM owns auth/store.
import { filterCatalog } from './workout.js';
export function libraryView(catalog, {query='', equipment='', bodyPart='', showAll=false, machines=[]}={}) {
 const supported=new Set(machines.filter(m=>m.status==='usable').flatMap(m=>{try{return JSON.parse(m.exercise_ids);}catch{return [];}}));
 const base=filterCatalog(catalog,query).filter(e=>!bodyPart||(e.bodyPart||e.bp||'')===bodyPart);
 const narrowed=showAll?base:base.filter(e=>supported.has(e.id));
 const equipmentOptions=[...new Set(narrowed.map(e=>e.equipment))].sort();
 const effectiveEquipment=equipmentOptions.includes(equipment)?equipment:'';
 return {rows:effectiveEquipment?narrowed.filter(e=>e.equipment===effectiveEquipment):narrowed,equipmentOptions,effectiveEquipment,
 bodyParts:[...new Set(catalog.map(e=>e.bodyPart||e.bp||'').filter(Boolean))].sort()};
}
